import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArtikelGruppeListComponent } from './artikelgruppen/artikel-gruppe-list/artikel-gruppe-list.component';
import { WebshopViewComponent } from './webshops/webshop-view/webshop-view.component';
import { WebshopHomeComponent } from './webshops/webshophome/webshophome.component';
import { CheckoutComponent } from './webshops/checkout/checkout.component';

const routes: Routes = [
    // {
    //     path:'',
    //     component: WebshopHomeComponent
    // },
    // {
    //     path: 'articles',
    //     component: WebshopViewComponent,
    // },
    // {
    //     path: 'checkout',
    //     component: CheckoutComponent,
    // },
   
    // {
    //     path: 'artikelgruppen',

    //     children: [
    //         {
    //             path: '',
    //             component: ArtikelGruppeListComponent,
    //         },
    //     ],
    // },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WebshopRoutingModule {}
